import React from 'react';
import { useDispatch } from 'react-redux';

import { Quotation } from 'services/action';
import { Page } from 'ui/components';
import {
  DetailQuotation,
  DetailNote,
  Services,
} from './component/detail';

const initialState = {
  data: null,
};

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();

  const [{ data }, setState] = React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(Quotation.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="col-12 col-md-8 bordered">
      <Page.Header
        pretitle="Quotation"
        title={data?.code}
        status={data?.document_status}
        backTo="/quotation"
      />

      <Page.Body className="bg-white border-top padding mt-3 mt-md-0">
        <DetailQuotation data={data} />

        <Services data={data} />

        <DetailNote data={data} />
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
